import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {RegistrationInstitution} from "../../models/registration-institution";
import {RegistrationUnit} from "../../models/registration-unit";

@Injectable()
export class RegistrationInstitutionControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getRegistrationInstitution(registrationId: string): Observable<RegistrationUnit> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/registration_institution") as Observable<RegistrationUnit>;
  }

  public getRegistrationInstitutionById(registrationInstitutionId: string): Observable<RegistrationUnit> {
    return this.http.get(this.baseUrl + "registration_institution/" + registrationInstitutionId) as Observable<RegistrationUnit>;
  }

  public getRegistrationInstitutionsByInstitutionId(institutionId: string): Observable<RegistrationInstitution[]> {
    return this.http.get(this.baseUrl + "registration_institution_by_institution/" + institutionId) as Observable<RegistrationInstitution[]>;
  }

  public createRegistrationInstitution(registrationId: string, institutionId: string) {
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/registration_institution", institutionId);
  }

  public deleteRegistrationInstitution<T>(registrationInstitutionId: string) {
    return this.http.delete(this.baseUrl + "registration_institution/" + registrationInstitutionId, {responseType: "text"});
  }
}
